export class SimpleObserver<K extends Record<string, unknown>> {
  private subscribers = new Set<(args: Partial<K>) => void>();
  private args: K = {} as K;

  subscribe(observer: (args: Partial<K>) => void) {
    this.subscribers.add(observer);
  }

  unsubscribe(observer: (args: Partial<K>) => void) {
    this.subscribers.delete(observer);
  }

  unsubscribeAll() {
    this.subscribers.clear();
  }

  update(args: Partial<K>) {
    this.args = {
      ...this.args,
      ...args,
    };

    return this;
  }

  notify() {
    this.subscribers.forEach((observer) => observer(this.args));
  }

  getValue(k: keyof K): K[keyof K] {
    return this.args[k];
  }
}
